import * as React from "react";
import { SVGProps } from "react";

const Monero = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3756 3756" {...props}>
    <path
      fill="#fff"
      d="M3756.04 1878.06c0 1037.19-840.74 1878.05-1878 1878.05S.04 2915.25.04 1878.06 840.8 0 1878.04 0s1878 840.79 1878 1878.06Z"
    />
    <path
      fill="#f26822"
      d="M1878.04 0C841.15 0-1.08 842.06.24 1878c.26 207.26 33.31 406.63 95.34 593.12h561.88V891.25l1220.58 1220.57L3098.56 891.25v1579.9h562c62.12-186.48 95-385.85 95.37-593.12C3757.7 841.01 2915.04.25 1878.04.25Z"
    />
    <path
      fill="#4d4d4d"
      d="m1597.34 2392.42-532.67-532.7v994.14H657.42l-384.29.07c329.63 540.8 925.35 902.56 1604.91 902.56s1275.31-361.84 1605-902.64h-791.75v-994.13l-532.7 532.7-280.61 280.61-280.62-280.61Z"
    />
  </svg>
);

export default Monero;
